"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmeraldSliderCoreInputs = void 0;
class EmeraldSliderCoreInputs {
    constructor() {
        this.value = 0;
        this.min = 0;
        this.max = 100;
        this.step = 1;
        this.isRange = false;
        this.disabled = false;
        this.isDiscrete = true;
        this.valueStart = 0;
        this.valueEnd = 0;
        this.hasTickMarks = false;
        this.showInput = false;
        this.required = false;
    }
}
exports.EmeraldSliderCoreInputs = EmeraldSliderCoreInputs;
//# sourceMappingURL=slider.inputs.js.map